import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export const CONSENT_TEXT = "I have read and agree to the Privacy Policy and Terms & Conditions.";

export function validateConsent(checked) {
  if (checked) return true;
  toast.error("Please tick the consent box to continue.");
  return false;
}

export default function ConsentCheckbox({ checked, onChange, testid, dark = false, className = "" }) {
  return (
    <label className={`flex items-start gap-3 cursor-pointer select-none ${className}`} data-testid={testid}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="w-5 h-5 mt-0.5 rounded border-slate-300 accent-[#FFC72C] shrink-0"
        data-testid={`${testid}-input`}
      />
      <span className={`text-xs leading-relaxed ${dark ? "text-slate-300" : "text-slate-500"}`}>
        I have read and agree to the{" "}
        <Link to="/privacy-policy" target="_blank" className="text-inherit no-underline hover:underline" onClick={(e) => e.stopPropagation()}>Privacy Policy</Link>
        {" "}and{" "}
        <Link to="/terms-conditions" target="_blank" className="text-inherit no-underline hover:underline" onClick={(e) => e.stopPropagation()}>Terms &amp; Conditions</Link>.
      </span>
    </label>
  );
}
